import TabAccess from './component/TabAccess';
import TabInvitation from './component/TabInvitation';
import TaskAccess, { TaskSubmissionAccess, TaskRegistrationRefresh, TaskOwnerAccess, TaskAccessManagement } from './TaskAccess';
import React, { useEffect, useMemo, useState } from "react";
import "./styles/index.less";
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  message,
  Layout,
  Input,
  Tabs,
  Spin,
  Breadcrumb,
  Tooltip,
} from "antd";
import {
  LockOutlined,
  SendOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import LogoBg from "../../assets/images/logo/benchmarklogo.png";
import { useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import { useSocket } from "../../utils/socketio/SocketWrapper";
import { useNavigate } from "react-router-dom";
import { get_role, user_login } from "../../services/user";
import { check_task_member, task_register } from "../../services/task_member";
import { get_task_id } from "../../services/task";
// import { queue_submit } from "../../services/submission";
import {
  team_getAll,
  team_getteamconfig,
  team_create,
  team_getMyTeam,
  team_getMyTaskRole,
} from "../../services/team";
// day js
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { useTranslation } from "react-i18next";
import localeData from "dayjs/plugin/localeData";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import TabInformation from "./component/TabInformation";
import TabTimeline from "./component/TabTimeline";
import TabMember from "./component/TabMember";
import TabEvaluation from "./component/TabEvaluation";
import TabHistory from "./component/TabHistory";
import TabLeaderboard from "./component/TabLeaderboard";
import SubmissionModal from "./component/SubmissionModal";
import TeamModal from "./component/TeamModal";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.extend(buddhistEra);
dayjs.locale("th");
dayjs.extend(localeData);

const { Content } = Layout;

type Props = {};

interface TaskDetail {
  id: number;
  task_id: string;
  type: number;
  name: string;
  tags: string;
  information: string;
  created_timestamp: string;
  updated_timestamp: string;
  status: number;
  img: string;
  dataset: string;
  resources: string;
  metrics: string;
  baseline_model: string;
  evaluation_script: string;
  submission_tutorial: string;
  datasheet: string;
  paper: string;
  submission_type: number;
  start_date: string;
  end_date: string;
  award_date: string;
  sponsors: string;
  qualification_show: number;
  qualification: string;
  award: string;
  award_show: number;
  note: string;
  note_show: number;
  contact: string;
  contact_show: number;
  event_date: string;
  submission_status: number;
}

const ConfigTaskmainpage = (props: Props) => {
  const canSubmitTask = React.useContext(TaskSubmissionAccess);
  const isTaskOwner = React.useContext(TaskOwnerAccess);
  const canManageAccess = React.useContext(TaskAccessManagement);
  const refreshTaskAccess = React.useContext(TaskRegistrationRefresh);
  const auth = useAuth();
  const { t } = useTranslation();
  const { socket, isConnected } = useSocket() as any;
  const joinedRoomRef = React.useRef<string | null>(null);
  let navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false);
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [hasTeam, setHasTeam] = useState<boolean>(false);
  const [myTeam, setMyTeam] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const params = useParams();
  const [taskDetail, setTaskDetail] = useState<TaskDetail[]>([]);
  const [sponsors, setSponsors] = useState<any[]>([]);
  const [memberDetail, setMemberDetail] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [evaluation, setEvaluation] = useState<any>([]);
  const [systemRole, setSystemRole] = useState<any>(null);
  const [systemRoleId, setSystemRoleId] = useState<string | null>(null);
  const [memberRole, setMemberRole] = useState<any>(null);
  const [hasHistoryAccess, setHasHistoryAccess] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<string>("1");
  const taskLocation = useLocation();
  useEffect(() => {
    if (new URLSearchParams(taskLocation.search).get('tab') === 'access' && canManageAccess) setActiveTab('access');
  }, [taskLocation.search, canManageAccess]);
  const [autoOpenCreateTeam, setAutoOpenCreateTeam] = useState(false);
  const [now, setNow] = useState(dayjs());
  // const [countQueue, setCountQueue] = useState<number>(0);
  const hasTeamRef = React.useRef(false);

  const eventDate = useMemo<any>(() => {
    try {
      if (!taskDetail[0]?.event_date) return {};
      const parsed =
        typeof taskDetail[0].event_date === "string"
          ? JSON.parse(taskDetail[0].event_date)
          : taskDetail[0].event_date;
      return Array.isArray(parsed) ? parsed[0] || {} : parsed;
    } catch {
      return {};
    }
  }, [taskDetail]);

  const isInRegisRange = useMemo(() => {
    if (taskDetail[0]?.type == 2) return true;
    if (eventDate.start_regis_date && eventDate.end_regis_date) {
      return (
        (now.isAfter(dayjs(eventDate.start_regis_date)) ||
          now.isSame(dayjs(eventDate.start_regis_date))) &&
        (now.isBefore(dayjs(eventDate.end_regis_date)) ||
          now.isSame(dayjs(eventDate.end_regis_date)))
      );
    }
    if (eventDate.start_regis_date) {
      return (
        now.isAfter(dayjs(eventDate.start_regis_date)) ||
        now.isSame(dayjs(eventDate.start_regis_date))
      );
    }
    if (eventDate.end_regis_date) {
      return (
        now.isBefore(dayjs(eventDate.end_regis_date)) ||
        now.isSame(dayjs(eventDate.end_regis_date))
      );
    }
    return true;
  }, [eventDate, now]);

  // update current time every 30 seconds for real-time deadline check
  useEffect(() => {
    const timer = setInterval(() => setNow(dayjs()), 30000);
    return () => clearInterval(timer);
  }, []);

  // auto-close submission modal when deadline passes
  // NOTE: disabled — admin can still submit after deadline, caused modal to close unexpectedly
  // useEffect(() => {
  //   if (isSubmissionModalOpen && isSubmissionExpired()) {
  //     setIsSubmissionModalOpen(false);
  //     message.warning("หมดเวลาส่งงานแล้ว");
  //   }
  // }, [now]);

  // api member
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await getTask();
        const memberStatus = await checkMember();
        await getMember(data);
        // getQueue();

        // เช็คว่า user มี team หรือยัง (ต้องเป็น member ก่อน)
        if (auth.user.role !== "User" && memberStatus) {
          await checkUserTeam();
          const roleRes = await team_getMyTaskRole({ task_id: params.id });
          if (roleRes.status === "success") setMemberRole(roleRes.task_role ?? null);
        }
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const s = socket?.current;
    const taskId = params.id;
    if (!s || !taskId || !isConnected) return;

    const room = `task:${taskId}`;

    // console.log("[detail task socket] join_room", {
    //   taskId,
    //   room,
    //   socketId: s.id,
    // });

    s.emit("join_room", room);
    joinedRoomRef.current = room;

    return () => {
      // console.log("[detail task socket] leave_room", {
      //   taskId,
      //   room,
      //   socketId: s.id,
      // });
      s.emit("leave_room", room);
      if (joinedRoomRef.current === room) joinedRoomRef.current = null;
    };
  }, [isConnected, socket, params.id]);

  useEffect(() => {
    const s = socket?.current;
    if (!s || !isConnected) return;

    const handleRefresh = (payload: any) => {
      // console.log("[detail task socket] receive", payload);
      if (payload?.task_id && params.id && payload.task_id !== params.id)
        return;

      (async () => {
        try {
          const data = await getTask();
          const memberStatus = await checkMember();
          await getMember(data);

          if (auth.user.role !== "User" && memberStatus) {
            await checkUserTeam("never");
          }
        } catch (e) {
          console.error(e);
        }
      })();
    };

    s.on("team_member_changed", handleRefresh);
    s.on("task:refresh", handleRefresh);

    return () => {
      s.off("team_member_changed", handleRefresh);
      s.off("task:refresh", handleRefresh);
    };
  }, [isConnected, socket, params.id, auth.user.role]);

  // useEffect(() => {
  //   const s = socket?.current;
  //   if (!s || !isConnected) return;

  //   const handleGetQueue = () => getQueue();
  //   s.on("getqueue", handleGetQueue);

  //   return () => {
  //     s.off("getqueue", handleGetQueue);
  //   };
  // }, [isConnected, socket]);

  // // get number of pending jobs in the system queue
  // const getQueue = async () => {
  //   try {
  //     const res = await queue_submit();
  //     const parsedData =
  //       typeof res.data === "string" ? JSON.parse(res.data) : res.data;
  //     const queues = parsedData?.queues || parsedData?.data?.queues || [];
  //     if (Array.isArray(queues)) {
  //       const totalMessages = queues.reduce(
  //         (sum: number, queue: any) => sum + queue.messages_ready,
  //         0,
  //       );
  //       setCountQueue(totalMessages);
  //     } else {
  //       setCountQueue(0);
  //     }
  //   } catch (e) {
  //     console.error("❌ Error fetching queue data:", e);
  //     setCountQueue(0);
  //   }
  // };

  // get detail task
  const getTask = async () => {
    try {
      const data = { task_id: params.id };
      const res = await get_task_id(data);
      const filteredTasks = res.result.filter(
        (task: any) => task.revoked_timestamp === null,
      );
      if (filteredTasks.length > 0) {
        const sponsorData = JSON.parse(filteredTasks[0].sponsors || "[]");
        setSponsors(sponsorData);
      }

      const result_evaluation = [
        { name: "Baseline Model", url: filteredTasks[0]?.baseline_model },
        {
          name: "Evaluation Script",
          url:
            JSON.parse(filteredTasks[0]?.evaluation_script || "{}")?.evaluation
              ?.public?.[0]?.link || null,
        },
        {
          name: "Submission Tutorial",
          url: filteredTasks[0]?.submission_tutorial,
        },
        {
          name: "Data Sheet",
          url: filteredTasks[0]?.datasheet,
        },
        {
          name: "Paper",
          url: filteredTasks[0]?.paper,
        },
      ];
      setEvaluation(result_evaluation);
      setTaskDetail(filteredTasks);

      return filteredTasks;
    } catch (e) {
      console.error(e);
    }
  };

  // check user for button
  const checkMember = async (): Promise<boolean> => {
    if (auth.user.role == "User") {
      setIsMember(false);
      return false;
    } else {
      try {
        const res = await check_task_member({
          user_id: auth.user.user_id,
          task_id: params.id,
        });
        if (res.status == "success") {
          setIsMember(res.result);
          return res.result;
        }
      } catch (e) {
        console.error(e);
      }
      return false;
    }
  };

  // get member
  const getMember = async (detail?: any) => {
    try {
      const data = {
        task_id: params.id,
        include_member: true,
      };
      const res = await team_getAll(data);
      if (res.status === "success" && Array.isArray(res.data)) {
        setMemberDetail(res.data);
      } else {
        console.warn("Unexpected data format:", res);
        setMemberDetail([]);
      }
      let role = "User";
      if (auth.user.role != "User") {
        const role_user = await get_role();
        role = role_user.result[0].role_name;
        setSystemRoleId(role_user.result[0]?.role_id ?? null);
      }
      const isSuperAdmin = role === "Super Admin";
      if (detail && detail[0] && detail[0].status == 0) {
        if (!isSuperAdmin) {
          setHasHistoryAccess(false);
        }
      }
      setSystemRole(role);
    } catch (e) {
      console.error("Error fetching team details:", e);
      setMemberDetail([]);
    }
  };

  // modal login
  const showModal = async () => {
    if (auth.user.role == "User") {
      localStorage.setItem("redirectPath", window.location.pathname);
      setIsModalOpen(true);
    } else {
      try {
        const res = await task_register({
          user_id: auth.user.user_id,
          task_id: params.id,
          role: 1,
        });
        if (
          Array.isArray(res) &&
          res.length > 0 &&
          res[0].status == "success"
        ) {
          message.success("Register Success!");
          await refreshTaskAccess();

          // Check team config - if team_size === 1, auto-create team
          try {
            const configRes = await team_getteamconfig({ task_id: params.id });
            if (
              configRes.status === "success" &&
              configRes.result &&
              configRes.result.length > 0
            ) {
              const teamSize = configRes.result[0].team_size || 15;

              if (teamSize === 1) {
                // Auto create team with user name
                const userName =
                  auth.user.user_name ||
                  auth.user.username ||
                  auth.user.name ||
                  auth.user.user_email?.split("@")[0] ||
                  auth.user.email?.split("@")[0] ||
                  `user_${auth.user.user_id}`;
                const createRes = await team_create({
                  task_id: params.id,
                  team_name: String(userName),
                  user_id: [auth.user.user_id],
                });

                if (createRes.status === "success") {
                  message.success("สร้างทีมอัตโนมัติสำเร็จ!");
                  hasTeamRef.current = true;
                  // set ทั้งคู่พร้อมกัน ป้องกัน joinTeamButton โผล่แปบนึง
                  setHasTeam(true);
                  setIsMember(true);
                  await getMember();
                } else {
                  setIsMember(true);
                  await getMember();
                  await checkUserTeam();
                }
              } else {
                setIsMember(true);
                await getMember();
                await checkMember();
                await checkUserTeam();
              }
            } else {
              setIsMember(true);
              await getMember();
              await checkMember();
              await checkUserTeam();
            }
          } catch (configError) {
            console.error("Error fetching team config:", configError);
            setIsMember(true);
            await getMember();
            await checkUserTeam();
          }
        } else if (Array.isArray(res) && res.length > 0) {
          message.warning("This user has already registered!");
        } else {
          message.error("Unexpected response format from API");
        }
      } catch (e) {
        console.error("Error in showModal:", e);
        message.error("Registration failed. Please try again.");
      }
    }
  };

  // Check if user has team
  // showModal: "if-not-dismissed" = เปิดถ้ายังไม่ dismiss, "always" = เปิดเสมอ, "never" = ไม่เปิด
  const checkUserTeam = async (showModal: "if-not-dismissed" | "always" | "never" = "if-not-dismissed") => {
    const dismissed = sessionStorage.getItem(`teamModal_dismissed_${params.id}`);
    try {
      const res = await team_getMyTeam({ task_id: params.id });
      if (res.status === "success" && res.data) {
        setMyTeam(res.data);
        setHasTeam(true);
        hasTeamRef.current = true;
      } else {
        setMyTeam(null);
        // ป้องกัน race condition: ถ้า auto-create team สำเร็จแล้ว อย่า reset กลับ
        if (!hasTeamRef.current) {
          setHasTeam(false);
        }
        if (
          showModal === "always" ||
          (showModal === "if-not-dismissed" && !dismissed)
        ) {
          setIsTeamModalOpen(true);
        }
      }
    } catch (e) {
      console.error(e);
      setMyTeam(null);
      if (!hasTeamRef.current) {
        setHasTeam(false);
      }
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // login
  const handleLogin = async (value: any) => {
    setSubmitting(true);
    try {
      const data = {
        user_email: value.email,
        password: value.password,
      };
      const res = await user_login(data);
      if (res.message == "success" && res.status == 1) {
        auth.login(res.result);
        const redirectPath = localStorage.getItem("redirectPath");
        if (redirectPath) {
          const cleanedPath = redirectPath.replace("/benchmark", "");
          localStorage.setItem("redirectPath", cleanedPath);
          navigate(cleanedPath);
          window.location.reload();
        } else {
          navigate("/");
        }
      } else if (res.message == "failed: user not found") {
        form.setFields([
          {
            name: "email",
            errors: ["ไม่มีผู้ใช้นี้ในระบบ"],
          },
        ]);
      } else {
        form.setFields([
          {
            name: "email",
            errors: [res.error_message],
          },
        ]);
      }
    } catch (e) {
      console.error(e);
      message.error("Email or password is incorrect, please try again !");
    }
    setSubmitting(false);
  };

  // tab 1 2 3 4 5 6
  const allTabItems = [
    {
      key: "1",
      label: t("Overview"),
      content: (
        <TabInformation
          taskDetail={taskDetail}
          sponsors={sponsors}
          evaluation={evaluation}
        />
      ),
    },
    {
      key: "2",
      label: t("Timeline"),
      content: <TabTimeline taskDetail={taskDetail} />,
    },
    {
      key: "3",
      label: t("member"),
      content: (
        <TabMember
          memberDetail={memberDetail}
          taskId={params.id || ""}
          currentUserId={auth.user?.user_id}
          userRole={systemRole}
          userRoleId={systemRoleId}
          isMember={isMember}
          myTeam={myTeam}
          onRefresh={() => { hasTeamRef.current = false; getMember(); checkUserTeam("if-not-dismissed"); }}
          autoOpenCreate={autoOpenCreateTeam}
          onAutoOpenCreateDone={() => setAutoOpenCreateTeam(false)}
        />
      ),
    },
    {
      key: "4",
      label: t("History"),
      content: <TabHistory taskDetail={taskDetail} />,
    },
    {
      key: "5",
      label: t("Leaderboard"),
      content: <TabLeaderboard taskDetail={taskDetail} activeTab={activeTab} />,
    },
    {
      key: "6",
      label: t("Dataset"),
      content: (
        <TabEvaluation
          taskDetail={taskDetail}
          evaluation={evaluation}
          isMember={isMember}
        />
      ),
    },
    ...(canManageAccess ? [{ key: 'access', label: 'Access', content: <TabAccess taskId={params.id || ''} canDelegate={isTaskOwner} /> }] : []),
    ...(isTaskOwner ? [
      { key: 'invitation', label: 'Invitation', content: <TabInvitation taskId={params.id || ''} /> },
    ] : []),
  ];

  // Filter out History tab if user doesn't have access
  const tabItems =
    hasHistoryAccess && isMember
      ? allTabItems
      : allTabItems.filter((tab) => tab.key !== "4");

  // name tab
  const items = tabItems.map((tab) => ({
    key: tab.key,
    label: tab.label,
    children: tab.content,
  }));

  // Helper function to check if submission button should be shown
  const shouldShowSubmissionButton = () => {
    if (!taskDetail[0] || !isMember) return false;
    if (taskDetail[0]?.type == 2) return true; // type 2 แสดงตลอด
    if (memberRole === 2) return true; // task admin แสดงตลอด
    // ซ่อนเฉพาะยังไม่ถึงเวลาเริ่ม, ถ้าหมดเวลาแล้วให้แสดงเป็น disabled แทน
    if (eventDate.start_date && now.isBefore(dayjs(eventDate.start_date))) return false;
    // if (eventDate.start_regis_date && now.isBefore(dayjs(eventDate.start_regis_date))) return false;
    // if (eventDate.end_regis_date && now.isAfter(dayjs(eventDate.end_regis_date))) return false; // ย้ายไปเช็คใน isSubmissionExpired แทน (disabled แทนการซ่อน)
    return true;
  };

  // ตรวจสอบว่าหมดเวลาส่งงานแล้วหรือยัง
  const isSubmissionExpired = () => {
    if (taskDetail[0]?.type == 2) return false;
    if (!eventDate.end_date) return false;
    return now.isAfter(dayjs(eventDate.end_date));
    // if (!eventDate.end_regis_date) return false;
    // return now.isAfter(dayjs(eventDate.end_regis_date));
  };

  // ปุ่ม Join Team
  const joinTeamButton = (
    <Button
      type="primary"
      style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", color: "white" }}
      onClick={() => setIsTeamModalOpen(true)}
    >
      <TeamOutlined />
      {t("Join Team")}
    </Button>
  );

  // ปุ่ม Submission
  const isExpired = isSubmissionExpired();
  const isSubmissionDisabled = !canSubmitTask || (memberRole !== 2 && (taskDetail[0]?.submission_status === 1 || isExpired));
  const submissionTooltip = !canSubmitTask ? "ต้องได้รับอนุมัติจากเจ้าของ Task ก่อนส่งงาน" : taskDetail[0]?.submission_status === 1
    ? "ห้ามส่งงานชั่วคราว"
    : isExpired
    ? "หมดเวลาส่งงาน"
    : "";
  const submissionButton = (
    <Tooltip title={submissionTooltip}>
      <Button
        type="primary"
        disabled={isSubmissionDisabled}
        style={{
          backgroundColor: isSubmissionDisabled ? "#8c8c8c" : "#AF52DE",
          borderColor: isSubmissionDisabled ? "#8c8c8c" : "#AF52DE",
          color: "white",
          opacity: 1,
          display: shouldShowSubmissionButton() ? "" : "none",
        }}
        onClick={() => setIsSubmissionModalOpen(true)}
      >
        <SendOutlined />
        {t("Submission")}
      </Button>
    </Tooltip>
  );

  const extraContent1 = (
    <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "flex-end" }}>
      {isMember ? (
        !hasTeam ? (
          joinTeamButton
        ) : taskDetail[0]?.type == 1 ? (
          systemRole == "Super Admin" ||
          memberRole == 2 ||
          // now.isAfter(dayjs(eventDate.start_date))
          now.isAfter(dayjs(eventDate.start_regis_date))
            ? submissionButton
            : null
        ) : (
          submissionButton
        )
      ) : isInRegisRange ? (
        <Button
          style={{ backgroundColor: "#FC4100", color: "white" }}
          size="large"
          onClick={showModal}
        >
          {t("Register")}
        </Button>
      ) : null}
    </div>
  );

  return (
    <Layout>
      <Content className="detail-task-layout">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Row justify="space-between">
              <Col>
                <Breadcrumb
                  separator=">"
                  items={[
                    {
                      title: (
                        <a
                          style={{ fontWeight: "bold" }}
                          onClick={(e) => {
                            e.preventDefault(); // ป้องกันรีเฟรช
                            navigate("/task");
                          }}
                        >
                          {t("Task")}
                        </a>
                      ),
                    },
                    {
                      title: (
                        <>
                          {taskDetail.map((task: any, index: number) => (
                            <span key={index} style={{ fontWeight: "bold" }}>
                              {task.name}
                            </span>
                          ))}
                        </>
                      ),
                    },
                  ]}
                />
              </Col>
              <Col>{extraContent1}</Col>
            </Row>
            <hr />

            {/* {isMember && shouldShowSubmissionButton() && (
              <div style={{ textAlign: "right", marginBottom: "10px", fontSize: 16, fontWeight: "bold" }}>
                {t("Number of queues in the system")} {countQueue} {t("Queue")}
              </div>
            )} */}

            {/* body */}
            <Content>
              <Tabs
                type="card"
                activeKey={activeTab}
                onChange={setActiveTab}
                items={items}
                style={{ margin: 0 }}
              />
            </Content>
          </>
        )}
      </Content>

      {/* login button */}
      <Modal
        title="Login"
        open={isModalOpen}
        footer={null}
        style={{ top: 20 }}
        onCancel={handleCancel}
      >
        <Form
          layout="vertical"
          form={form}
          name="login-form"
          initialValues={{
            autoLogin: true,
            email: "",
            password: "",
          }}
          style={{ padding: "20px" }}
          onFinish={async (values) => {
            handleLogin(values);
          }}
        >
          <Col style={{ textAlign: "center", marginBottom: "20px" }}>
            <img src={LogoBg} height={100}></img>
            {/* <p className="form-title" style={{ color: "rgb(101 100 100)" }}>Welcome</p> */}
          </Col>

          <Form.Item
            label="Email / Username *"
            name="email"
            rules={[
              { type: "string", message: "The input is not a valid e-mail" },
              {
                required: true,
                message: "Please input your email or username!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Email or username"
            />
          </Form.Item>

          <Form.Item
            label="Password *"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item>
            <a
              className="login-form-forgot"
              onClick={() => {
                setIsModalOpen(false);
                navigate("/user/forgot/reset");
              }}
            >
              Forgot password
            </a>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={submitting}
              style={{
                background:
                  "linear-gradient(90deg, rgba(137,33,107,1) 0%, rgba(137,33,107,1) 35%,  rgba(218,68,83,1) 100%)",
                padding: "0px",
              }}
            >
              Login
            </Button>

            <Form.Item className="center-text">
              <span>Don't have an account? </span>
              <a onClick={() => navigate("/user/register/new")}>Sign up</a>
            </Form.Item>
          </Form.Item>
        </Form>
      </Modal>

      {/* Submission Modal */}
      <SubmissionModal
        visible={isSubmissionModalOpen}
        onClose={() => setIsSubmissionModalOpen(false)}
        onSubmitSuccess={() => setActiveTab("4")}
        taskId={params.id || ""}
        taskName={taskDetail[0]?.name || ""}
        taskDetail={taskDetail[0]}
        userCode={auth.user.user_code}
        isTaskAdmin={memberRole === 2}
      />

      {/* Team Modal */}
      <TeamModal
        visible={isTeamModalOpen}
        onClose={(dismissed) => {
          setIsTeamModalOpen(false);
          if (dismissed) {
            sessionStorage.setItem(`teamModal_dismissed_${params.id}`, "true");
          }
        }}
        onNavigateWithMode={(mode) => {
          setActiveTab("3");
          if (mode === "create") setAutoOpenCreateTeam(true);
        }}
        taskId={params.id || ""}
        userId={auth.user.user_id}
      />
    </Layout>
  );
};

export default function ProtectedTaskPage() {
  const { id } = useParams();
  const auth = useAuth();
  return <TaskAccess key={`${id}:${auth.user?.user_id || "guest"}`}><ConfigTaskmainpage /></TaskAccess>;
}
